/** Fetch the normalized zones FeatureCollection from the backend. */
export async function fetchZones() {
  // Always revalidate on load — a "free right now" app must not show a stale
  // tariff snapshot cached by the browser.
  const res = await fetch('/api/zones', { cache: 'no-cache' })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.detail || body.error || `HTTP ${res.status}`)
  }
  const data = await res.json()
  return {
    data,
    source: res.headers.get('X-Data-Source'),
    updatedAt: res.headers.get('X-Data-Updated'),
  }
}

export async function fetchMeta() {
  const res = await fetch('/api/meta')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
